import clsx from 'clsx'
import {KTIcon} from '../../../helpers'
import {BrandThemeType, useBrandTheme} from './BrandThemeProvider'

/* eslint-disable jsx-a11y/anchor-is-valid */
type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
  menuPlacement?: string
  menuTrigger?: string
}

type BrandOption = {
  id: BrandThemeType
  title: string
  swatchColor: string
}

const brandOptions: Array<BrandOption> = [
  {id: 'indigo', title: 'Índigo & Dourado', swatchColor: '#3e4095'},
  {id: 'celeste', title: 'Celeste & Rosa', swatchColor: '#4a90d9'},
  {id: 'violeta', title: 'Violeta & Âmbar', swatchColor: '#7c3aed'},
]

const BrandThemeSwitcher = ({
  toggleBtnClass = '',
  toggleBtnIconClass = 'fs-1',
  menuPlacement = 'bottom-end',
  menuTrigger = "{default: 'click', lg: 'hover'}",
}: Props) => {
  const {brand, updateBrand} = useBrandTheme()

  return (
    <>
      {/* begin::Menu toggle */}
      <a
        href='#'
        title='Tema de cores'
        className={clsx('btn btn-icon ', toggleBtnClass)}
        data-kt-menu-trigger={menuTrigger}
        data-kt-menu-attach='parent'
        data-kt-menu-placement={menuPlacement}
      >
        <KTIcon iconName='color-swatch' className={toggleBtnIconClass} />
      </a>
      {/* end::Menu toggle */}

      {/* begin::Menu */}
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-225px'
        data-kt-menu='true'
      >
        {/* begin::Menu heading */}
        <div className='menu-item px-3 my-0'>
          <div className='menu-content px-3 py-2 text-muted text-uppercase fs-8 fw-bold'>
            Tema de cores
          </div>
        </div>
        {/* end::Menu heading */}

        {brandOptions.map((option) => (
          <div className='menu-item px-3 my-0' key={option.id}>
            <a
              href='#'
              className={clsx('menu-link px-3 py-2', {active: brand === option.id})}
              onClick={() => updateBrand(option.id)}
            >
              <span className='menu-icon' data-kt-element='icon'>
                <span
                  className='d-inline-block w-20px h-20px rounded-circle border border-gray-300'
                  style={{backgroundColor: option.swatchColor}}
                />
              </span>
              <span className='menu-title'>{option.title}</span>
            </a>
          </div>
        ))}
      </div>
      {/* end::Menu */}
    </>
  )
}

export {BrandThemeSwitcher}
